<template>
  <!-- 成员 -->
  <div class="content">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="finishText"
      @load="handleGetPostList"
    >
      <div class="list" v-if="list.length > 0">
        <div v-for="(item,index) in list" :key="item.id">
           <!-- 管理员 -->
           <div  class="list_item" v-if="!item.students && item.groupName === 'CLASS_ADMINS_MARK_IT'">
            <div class="avatar">
              <img class="img" :src="userAvatar[item.roleType]" alt=""/>
            </div>
            <div class="info">
              <div class="user">
                <div class="user_data">
                  <span class="name">
                    {{ item.userInfo && item.userInfo.realName }}
                  </span>
                  <span class="user_type">
                    <img
                      v-if="item.roleType == 1"
                      class="img1"
                      src="../../../assets/student/frame_admin.png"
                      alt=""
                    />
                    <!-- <img
                      v-if="item.roleType == 3"
                      class="img3"
                      src="../../../assets/student/frame_two.png"
                      alt=""
                    /> -->
                    <img
                      v-if="item.roleType == 2"
                      class="img2"
                      src="../../../assets/student/frame_one.png"
                      alt=""
                    />
                    <template v-if="item.roleType == 3">
                      <img src="../../../assets/images/grade/icon-invited.png" alt="" class="icon-status" v-if="item.userStatus == 2"/>
                      <img src="../../../assets/images/grade/icon-ok.png" alt="" class="icon-status" v-if="item.userStatus == 1"/>
                    </template>
                  </span>
                </div>
                <div class="study_report"
                v-if="(userInfo.memberType===1 && item.roleType == 3 && item.userStatus == 1)||(item.roleType == 3 && item.userStatus == 1&& item.isMe)"
                @click="handleGo(item)">
                  <p class="report-title">学情报告</p>
                  <div class="study-right"></div>
                </div>
              </div>
              <div class="hospital">{{  item.userInfo && item.userInfo.hospitalName }}</div>
            </div>
          </div>
          <div  class="list_item gruop-menu" v-else>
            <div  class="group-box">
              <div class="group-item" :class="item.isDropDown && (item.students && item.students.length) ? 'border' :''">
                <div class="avatar">
                  <img class="img" src="../../../assets/images/grade/mask-group-q.png" alt="" v-if="item.groupName === 'CLASS_UNGROUPED_MARK_IT'"/>
                  <img class="img" src="../../../assets/images/grade/mask-group.png" alt="" v-else/>
                </div>
                <div class="info" @click="changeSwitchGroup(item,index)">
                  <div class="user user-no">
                    <div class="user_data">
                      <span class="name">{{ item.groupName === 'CLASS_UNGROUPED_MARK_IT' ? '未分组' :item.groupName }}
                      </span>
                    </div>
                    <div class="drop-down">
                      <img src="../../../assets/images/grade/drop-down.png" alt="" class="icon-drop" v-if="item.isDropDown"/>
                      <img src="../../../assets/images/grade/drop-up.png" alt="" class="icon-drop" v-else/>
                    </div>
                  </div>
                </div>
              </div>
              <div class="group-menu" v-if="item.isDropDown && item.students && item.students.length" >
                <div  class="list_item" v-for="(aitem,aindex) in item.students" :key="aindex">
                  <div class="avatar">
                    <img class="img" :src="userAvatar[aitem.roleType]" alt=""/>
                  </div>
                  <div class="info">
                    <div class="user">
                      <div class="user_data acenter">
                        <span class="name">
                          {{ aitem.userInfo && aitem.userInfo.realName }}
                        </span>
                        <span class="user_type">
                          <img
                            v-if="aitem.roleType == 1"
                            class="img1"
                            src="../../../assets/student/frame_admin.png"
                            alt=""
                          />
                          <!-- <img
                            v-if="aitem.roleType == 3"
                            class="img3"
                            src="../../../assets/student/frame_two.png"
                            alt=""
                          /> -->
                          <img
                            v-if="aitem.roleType == 2"
                            class="img2"
                            src="../../../assets/student/frame_one.png"
                            alt=""
                          />
                          <template v-if="aitem.roleType == 3">
                            <img src="../../../assets/images/grade/icon-invited.png" alt="" class="icon-status" v-if="aitem.userStatus == 2"/>
                            <img src="../../../assets/images/grade/icon-ok.png" alt="" class="icon-status" v-if="aitem.userStatus == 1"/>
                          </template>
                        </span>
                      </div>
                      <!-- -->
                      <div class="study_report"
                      v-if="(userInfo.memberType===1 && aitem.roleType == 3 && aitem.userStatus == 1)||(aitem.roleType == 3 && aitem.userStatus == 1&& aitem.isMe)"
                      @click="handleGo(aitem)">
                        <p class="report-title">学情报告</p>
                        <div class="study-right"></div>
                      </div>
                    </div>
                    <div class="hospital">{{  aitem.userInfo && aitem.userInfo.hospitalName }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="empty-block" v-else-if="isNone">
        <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
        <div class="empty-txt">暂无内容</div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { selectUserList } from '@/api/grade'
import { userAvatar } from '../data'
export default {
  props: {
    classId: ''
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      pageObj: {
        pageNo: 1,
        pageSize: 10
      },
      searchContent: '',
      userAvatar,
      isNone: false,
      finishText: '没有更多了'
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    changeSwitchGroup(item, index) {
      this.list[index].isDropDown = !this.list[index].isDropDown
      this.$forceUpdate()
    },
    handleGo(item) {
      this.$router.push({
        path: '/studyReport',
        query: {
          iepOpenId: item.userInfo.iepOpenId,
          typeSource: 'grade',
        }
      })
    },
    handleGetPostList() {
      let params = {
        userId: this.userInfo.id,
        pageNum: this.pageObj.pageNo,
        pageSize: this.pageObj.pageSize,
        classId: this.classId,
      }
      selectUserList(params)
        .then(res => {
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data) {
              this.loading = false
              this.finished = true
              return false
            }

            this.loading = false
            if (res.data.length < this.pageObj.pageSize) {
              this.finished = true
            }
            if (res.code === 0 && res.data) {
              this.list = this.list.concat(res.data)
              this.list = this.list.flatMap(group => {
                group.isDropDown = true
                if (group.groupName === 'CLASS_ADMINS_MARK_IT' && group.students) {
                  // 如果是 CLASS_ADMINS_MARK_IT 分组，拆分 students
                  return group.students.map(student => ({
                    groupName: group.groupName,
                    ...student
                  }))
                } else {
                  // 其他分组保持不变
                  return [group]
                }
              })
            }
            this.pageObj.pageNo++
            if (this.list.length === 0) {
              this.isNone = true
              this.finishText = ''
            }
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
    }
  }
}
</script>

<style scoped lang="less">
.content {
  // height: 100%;
  min-height: calc(100vh - 214px);
  background: linear-gradient(180deg, #f6f8fa 6%, #edf1f4 8%, #f2f7fa 100%);
}
.list {
  padding: 10px 16px;
  box-sizing: border-box;
  background: linear-gradient(
    180deg,
    #f6f8fa 0%,
    #f6f8fa 6%,
    #f6f8fa 8%,
    #f6f8fa 100%
  );
  .list_item {
    width: 343px;
    // min-height: 74px;
    margin-bottom: 8px;
    background-color: #fff;
    border-radius: 12px;
    padding: 14px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .group-box{
      width: 100%;
      .group-item{
        display: flex;
        align-items: center;
        height: 62px;
        padding:0 10px;
      }
      .border{
        border-bottom: 1px solid #E6EBEE;
      }
      .group-menu{
        padding:10px 7px;
        .list_item{
          background: #F0F5F8 !important;
          width: 100%;
          &:last-child{
            margin-bottom: 0;
          }
        }
      }
    }
    .avatar {
      width: 42px;
      min-width: 42px;
      height: 42px;
      margin-right: 6px;
      border-radius: 50%;
      overflow: hidden;
      .img {
        width: 42px;
        min-width: 42px;
        height: 42px;
      }
    }
    .info {
      width: 260px;
      .user {
        display: flex;
        justify-content: space-between;
        margin-bottom: 8px;
        align-items: center;
        .user_data {
          display: flex;
          // align-items: center;
          overflow: hidden;
          flex: 1;
          .name {
            margin-right: 4px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #000000;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .user_type {
            transform: translateY(2px);
            display: flex;
            .img1 {
              width: 56px;
              height: 13px;
              margin-left: 2px;
            }
            .img2 {
              width: 38px;
              height: 13px;
              margin-left: 2px;
            }
            .img3{
              width: 29px;
              height: 13px;
              margin-left: 2px;
            }
            .icon-status{
              width: 39px;
              height: 13px;
              margin-left: 4px;
            }
            .level-group{
              height: 13px;
              box-sizing: border-box;
              position: relative;
              border: 1px solid #EB1700;
              border-radius: 2px;
              padding:0 6px;
              font-family: Source Han Sans CN, Source Han Sans CN;
              font-weight: 500;
              font-size: 10px;
              line-height: 12px;
              color: #EB1700;
              margin-left: 4px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .acenter{
          align-items: center;
        }
        .study_report{
          display: flex;
          align-items: center;
          justify-content: center;
          width: 82px;
          height: 24px;
          border-radius: 22px 22px 22px 22px;
          background: #F9F8F7;
          .report-title{
            font-weight: 400;
            font-size: 14px;
            color: #000;
          }
          .study-right{
            background: url('../../../assets/images/grade/icon-right.png') no-repeat center center / 100% 100%;
            width: 6px;
            height: 10px;
            margin-left: 4px;
          }
        }
        .drop-down{
          .icon-drop{
            width: 13px;
            height: 8px;
          }
        }
        .time {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 12px;
          color: #7a8494;
        }
      }
      .user-no{
        margin-bottom: 0;
      }
      .hospital {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        font-size: 14px;
        color: #7a8494;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .gruop-menu{
    padding: 0;
    // box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.06);
  }
}
.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 60px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/studentList.vue